/**
 * Framed videos go full-screen on click, and [data-vopen] players open in a lightbox.
 */

function framedVideos() {
    var videos = document.querySelectorAll('.frame--video video');

    for (var i = 0; i < videos.length; i++) {
        (function (video) {
            video.addEventListener('click', function (event) {
                // Native controls sit inside the element's own box, so clicks in the
                // bottom control strip are left to the browser.
                var rect = video.getBoundingClientRect();
                if (video.controls && event.clientY > rect.bottom - 54) { return; }
                if (document.fullscreenElement || document.webkitFullscreenElement) { return; }

                var request = video.requestFullscreen || video.webkitRequestFullscreen || video.webkitEnterFullscreen;
                if (!request) { return; }

                event.preventDefault();
                Promise.resolve(request.call(video))
                    .then(function () {
                        if (video.paused) { video.play().catch(function () {}); }
                    })
                    .catch(function () {});
            });
        })(videos[i]);
    }
}

function lightbox() {
    var triggers = document.querySelectorAll('[data-vopen]');
    if (!triggers.length) { return; }

    var pop = document.createElement('div');
    pop.className = 'vidpop';
    pop.setAttribute('role', 'dialog');
    pop.setAttribute('aria-modal', 'true');

    var stage = document.createElement('div');
    stage.className = 'vstage';

    var frame = document.createElement('iframe');
    frame.setAttribute('allow', 'autoplay; fullscreen; picture-in-picture');
    frame.setAttribute('allowfullscreen', '');
    frame.setAttribute('title', 'Video');
    stage.appendChild(frame);

    var close = document.createElement('button');
    close.type = 'button';
    close.className = 'popclose';
    close.textContent = 'Close';

    pop.append(stage, close);
    document.body.appendChild(pop);

    var opener = null;

    function hide() {
        if (!opener) { return; }
        pop.removeAttribute('data-on');
        // Leaving the src in place keeps the player alive and audible behind a hidden overlay.
        frame.removeAttribute('src');
        var previous = opener;
        opener = null;
        previous.focus({ preventScroll: true });
    }

    close.addEventListener('click', hide);
    pop.addEventListener('click', function (event) {
        if (!stage.contains(event.target) && event.target !== close) { hide(); }
    });

    addEventListener('keydown', function (event) {
        if (!opener) { return; }
        if (event.key === 'Escape') {
            hide();
            return;
        }
        if (event.key === 'Tab') {
            event.preventDefault();
            close.focus({ preventScroll: true });
        }
    });

    for (var i = 0; i < triggers.length; i++) {
        (function (trigger) {
            trigger.addEventListener('click', function () {
                opener = trigger;
                frame.setAttribute('title', trigger.dataset.vtitle || 'Video');
                frame.src = trigger.dataset.vopen;
                pop.setAttribute('data-on', '');
                close.focus({ preventScroll: true });
            });
        })(triggers[i]);
    }

    // ?open-modal=<trigger id> opens that video straight away, so a campaign link can
    // land someone on the page with the trailer already playing.
    var want = new URLSearchParams(location.search).get('open-modal');
    if (want) {
        var trigger = document.getElementById(want);
        if (trigger && trigger.dataset.vopen) { trigger.click(); }
    }
}

export default function video() {
    framedVideos();
    lightbox();
}
